import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface SuccessAlertProps {
    message: string;
    onDismiss?: () => void;
}

export default function SuccessAlert({
    message,
    onDismiss,
}: SuccessAlertProps) {
    return (
        <Box
            sx={{
                p: 1,
                pl: 2,
                borderRadius: 1,
                backgroundColor: "success.light",
                color: "success.contrastText",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
            }}
        >
            <Typography variant="body2">{message}</Typography>
            {onDismiss && (
                <IconButton
                    size="small"
                    onClick={onDismiss}
                    sx={(theme) => ({
                        color: "success.contrastText",
                        p: 0.5,
                        "&:hover": {
                            backgroundColor: theme.palette.mode === "dark" 
                                ? "rgba(255, 255, 255, 0.1)"
                                : "rgba(0, 0, 0, 0.1)",
                        },
                    })}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            )}
        </Box>
    );
}
